import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
`;

export const ProjectContainer = styled.div`
  transform: translate(0px, -100px);
  margin-right: 10px;
  margin-left: 10px;
`;

export const ProjectsList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  max-width: 1000px;
  margin: 0 auto;

  background-color: #fff;

  @media only screen and (max-width: 1000px) {
    grid-template-columns: 1fr;
  }
`;
